import {
    ConditionalRender,
    isFailed,
    isShowLoader,
    useAppSelector,
    useNavigationBlockerViaHistory,
    useSystemAction,
    useTranslation,
    useTriggerAction,
    useUiaRequestStats,
} from '@libs/core';
import { ActionSystemActionType, AssetsSvgMap, TCommonData, TWidget } from '@libs/types';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { CommonScreen } from './common/CommonScreen/CommonScreen';
import { TranslationKeys } from './types/enums';
import styled from './widgetWrapper.module.css';

const LOADER_DELAY = 800;

export const WidgetWrapper = ({ children }: { children: React.ReactNode }) => {
    const isLoader = useAppSelector(isShowLoader);
    const isStatusFlailed = useAppSelector(isFailed);
    const navigate = useNavigate();

    const { triggerAction } = useTriggerAction({} as TWidget<TCommonData>, true);
    const { t } = useTranslation();
    const systemActionNavigateBack = useSystemAction(ActionSystemActionType.navigateBack);
    useNavigationBlockerViaHistory(true, { triggerAction, systemActionNavigateBack });
    const uiaStats = useUiaRequestStats();

    useEffect(() => {
        if (isLoader) {
            // @ts-expect-error
            document?.activeElement?.blur?.();
        }
    }, [isLoader, uiaStats.isSlowConnection]);

    return (
        <>
            <ConditionalRender condition={isStatusFlailed}>
                <CommonScreen
                    useIcon={false}
                    fill="pink_100"
                    iconName={AssetsSvgMap.ic_x_circle_thin_80}
                    mainText={t(TranslationKeys.GeneralErrorText, 'Something went wrong...')}
                    buttonLabel={t(TranslationKeys.ButtonRetry, 'Try again')}
                    buttonHandleClick={() => {
                        navigate('/clearSession');
                    }}
                />
            </ConditionalRender>
            <ConditionalRender condition={isLoader}>
                <div className={styled.overlayContainer}>
                    <ConditionalRender condition={isLoader} delay={LOADER_DELAY}>
                        <CommonScreen useBackground={false} useSpinner secondaryText={t(TranslationKeys.Hangon, 'Hang on...')} />
                    </ConditionalRender>
                </div>
            </ConditionalRender>
            <ConditionalRender condition={!isStatusFlailed}>{children}</ConditionalRender>
        </>
    );
};
